import {WidgetText} from "../models/widgets/Text";
import {WidgetTable} from "../models/widgets/Table";
import {WidgetTableSearch} from "../models/widgets/TableSearch";
import {WidgetTableWithChart} from "../models/widgets/TableWithChart";
import {WidgetStatistic} from "../models/widgets/Statistic";
import {WidgetStatisticWithChart} from "../models/widgets/StatisticWithChart";
import {WidgetGoal} from "../models/widgets/Goal";
import {WidgetChart} from "../models/widgets/Chart";
import {WidgetChartPie} from "../models/widgets/ChartPie";
import {WidgetCollapse} from "../models/widgets/Collapse";
import {WidgetTree} from "../models/widgets/Tree";
import {WidgetMap} from "../models/widgets/Map";
import {WidgetFormAction} from "../models/widgets/FormAction";
import {Widget} from "../models/widgets";
import {WidgetShifts} from "../models/widgets/Shifts";
import {WidgetImageLink} from "../models/widgets/ImageLink";
import {FieldText} from "../models/fields/Text";
import {FieldTextArea} from "../models/fields/TextArea";
import {FieldNumber} from "../models/fields/Number";
import {FieldMultiselect} from "../models/fields/Multiselect";
import {FieldSelect} from "../models/fields/Select";
import {FieldTreeSelect} from "../models/fields/TreeSelect";
import {FieldRadio} from "../models/fields/Radio";
import {FieldDate} from "../models/fields/Date";
import {FieldRangeDate} from "../models/fields/RangeDate";
import {FieldMonthDate} from "../models/fields/MonthDate";
import {FieldRemoteSearch} from "../models/fields/RemoteSearch";
import {FieldBlank} from "../models/fields/Blank";
import {FieldLine} from "../models/fields/Line";
import {Field} from "../models/fields";
import {CustomButton} from "../models/buttons";
import {Col, Row, Tabs} from "antd";
import React, {useMemo} from "react";
import {FieldCalculated} from "../models/fields/Calculated";
import {WidgetTableForm} from "../models/widgets/TableForm";
import {transformFieldToColumn} from "./TransformActionTable";
import {WidgetIframe} from "../models/widgets/Iframe";
import {FieldFile} from "../models/fields/File";
import {FieldHeader} from "../models/fields/Header";
import {WidgetQr} from "../models/widgets/Qr";
import {WidgetStlObject} from "../models/widgets/StlOject";
import {WidgetDataDisplay} from "../models/widgets/DataDisplay";
import {FieldTreeCheck} from "../models/fields/TreeCheck";
import {FieldCheckbox} from "../models/fields/Checkbox";
import {FieldDateTime} from "../models/fields/DateTime";
import {FieldMultiDate} from "../models/fields/MultiDate";
import {WidgetTask} from "../models/widgets/Task";
const { TabPane } = Tabs;

export const transformRow = (data) => {
  switch (data.type) {
    case "tab":
      return {
        type: data.type,
        tabs: data.tabs.map(transformTab)
      }
    case "row":
      return ({
        type: data.type,
        columns: data.columns.map(transformColumn)
      })
  }
};

export const transformColumn = (data) => {
  if(data.type === 'column') {
    return ({
      type: data.type,
      size: data.size,
      rows: data.rows.map(transformRow)
    });
  }
  else {
     return transformWidget(data);
  }
}

export const transformTab = (data) => {
  return ({
    title: data.title,
    rows: data.rows?.map(transformRow)
  })
};
export const transformWidget = (data) => {
  switch (data.type) {
    case 'text':
      return new WidgetText().transformToWidget(data);
    case 'table':
      return new WidgetTable().transformToWidget(data);
    case 'table-search':
      return new WidgetTableSearch().transformToWidget(data);
    case 'table-chart':
      return new WidgetTableWithChart().transformToWidget(data);
    case 'table-form':
      data.headers = data.fields.map(transformFieldToColumn);
      data.fields = data.fields.map(transformField);
      return new WidgetTableForm().transformToWidget(data);
    case 'statistic':
      return new WidgetStatistic().transformToWidget(data);
    case 'statistic-chart':
      return new WidgetStatisticWithChart().transformToWidget(data);
    case 'goal':
      return new WidgetGoal().transformToWidget(data);
    case 'chart':
      return new WidgetChart().transformToWidget(data);
    case 'chart-pie':
      return new WidgetChartPie().transformToWidget(data);
    case 'shifts':
      return new WidgetShifts().transformToWidget(data);
    case 'collapse':
      return new WidgetCollapse().transformToWidget(data);
    case 'tree':
      return new WidgetTree().transformToWidget(data);
    case 'iframe':
      return new WidgetIframe().transformToWidget(data);
    case 'map':
      return new WidgetMap().transformToWidget(data);
    case 'task':
      return new WidgetTask().transformToWidget(data);
    case 'stl':
      return new WidgetStlObject().transformToWidget(data);
    case 'qr':
      return new WidgetQr().transformToWidget(data);
    case 'image-link':
      return new WidgetImageLink().transformToWidget(data);
    case 'data-display':
      return new WidgetDataDisplay().transformToWidget(data);
    case 'form-action': case 'section':
      data.fields = data.fields.map(transformField);
      data.buttons = data.buttons?.map(transformButton);
      return new WidgetFormAction().transformToWidget(data);
    case 'undefined':
      return {
        getComponent: function() {
          return () => <></>
        }
      };
    default:
      return new Widget().transformToWidget(data);
  }
}

// ---------------- Form ----------------

export const transformField = (data) => {
  switch (data.type) {
    case 'text':
      return new FieldText(data).transformToField(data);
    case 'textarea':
      return new FieldTextArea(data).transformToField(data);
    case 'number':
      return new FieldNumber(data).transformToField(data);
    case 'multiselect':
      return new FieldMultiselect(data).transformToField(data);
    case 'select':
      return new FieldSelect(data).transformToField(data);
    case 'treeselect':
      return new FieldTreeSelect(data).transformToField(data);
    case 'radio':
      return new FieldRadio(data).transformToField(data);
    case 'checkbox':
      return new FieldCheckbox(data).transformToField(data);
    case 'date':
      return new FieldDate(data).transformToField(data);
    case 'rangedate':
      return new FieldRangeDate(data).transformToField(data);
    case 'monthdate':
      return new FieldMonthDate(data).transformToField(data);
    case 'remotesearch':
      return new FieldRemoteSearch(data).transformToField(data);
    case 'calculated':
      return new FieldCalculated(data).transformToField(data);
    case 'treecheck':
      return new FieldTreeCheck(data).transformToField(data);
    case 'file':
      return new FieldFile(data).transformToField(data);
    case 'blank':
      return new FieldBlank(data).transformToField(data);
    case 'line':
      return new FieldLine(data).transformToField(data);
    case 'header':
      return new FieldHeader(data).transformToField(data);
    case 'datetime':
      return new FieldDateTime(data).transformToField(data);
    case 'multidate':
      return new FieldMultiDate(data).transformToField(data);
    default:
      return new Field(data).transformToField(data);
  }
}

export const transformButton = (data) => {
  switch (data.type) {
    default:
      return new CustomButton().transformToField(data);
  }
}


// --------------- Builder Dashboard  -------------------

export const builderDashboard = (element, formData) => {
  if(element.type !== 'column' && element.type !== 'row' && element.type !== 'tab'){
    return (
      <Col xs={24} sm={24} md={element.size}>
        <RenderWidget element={element} formData={formData}/>
      </Col>
    );
  }
  if(element.type === 'column') {
    return (
      <Col xs={24} sm={24} md={element.size}>
        {element.rows.map(element => builderDashboard(element, formData))}
      </Col>
    );
  }
  if(element.type === 'row') {
    return (
      <Row gutter={16}>
        {element.columns.map(element => builderDashboard(element, formData))}
      </Row>
    );
  }
  if(element.type === 'tab') {
    return (
      <Col xs={24} sm={24} md={element.size}>
        <Tabs>
          {element.tabs.map( tab => <TabPane tab={tab.title} key={tab.title}>
              {tab.rows?.map(element => builderDashboard(element, formData))}
            </TabPane>
          )}
        </Tabs>
      </Col>
    );
  }
}

const RenderWidget = ({element, formData}) => {
  const WidgetComponent = useMemo(() => element.getComponent({formData}), [element]);

  return <WidgetComponent/>
}
